import { baseRequest } from './base'
// 资讯api

/**
 * @desc 新闻列表
 */
function listNews(params) {
    params = utils.common.checkNull(params);
    //清除空白字段
    let tempUrl = '/api/news/list'
    return baseRequest(tempUrl, 'get', params);
  }
  
  /**
   * @desc 新建新闻
   */
  function createNews(params) {
    return baseRequest(`/api/news/create`, 'post', params);
  }
  
  /**
   * @desc 修改新闻
   */
  function updateNews(id, params) {
    return baseRequest(`/api/news/update/${id}`, 'post', params);
  }
  
  /**
   * @desc 删除新闻
   */
  function deleteNews(id) {
    return baseRequest(`/api/news/delete/${id}`, 'get');
  }
  
  /**
   * @desc 上下架
   */

  function enable(params) {
    params = utils.common.checkNull(params);
    //清除空白字段
    let tempUrl = '/api/news/enable'
    return baseRequest(tempUrl, 'get', params);
  }
  
  export default {
    listNews: listNews,
    createNews: createNews,
    updateNews: updateNews,
    deleteNews: deleteNews,
    enable: enable
  }